import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchdaySlider from '../MatchdaySlider';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class PrimeraB2025 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 1189; i <= 1221; i++) {
		if(i!==1193 && i!=1195 && i!=1200){
        	id_list.push(i);
		}
        }
    this.state = {
	kits:[],
        maxMatchday: 30,
	kit_path: '/images/kits/todas/',
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      color2:['#295e1e','#ffa500','#ffa500','#ffa500','#ffa500','#ffa500','#ffa500','#ffa500',
              0, 0,0,0,0,0,0,'#ff3355'],
	table2: []
/*	table2:[
              {'color':'#ffa500','shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':30, 'pg':14,'pe':8,'pp':8,'gf':44,'gc':42,'dif':2, 'pts':50},
		{'color':0,'shortname':'recoleta', 'rivalName':'Dep. Recoleta', 'pj':30, 'pg':8,'pe':11,'pp':11,'gf':28,'gc':37,'dif':-9, 'pts':35},
                {'color':0,'shortname':'sanfelipe', 'rivalName':'U. San Felipe', 'pj':30, 'pg':8,'pe':6,'pp':16,'gf':30,'gc':38,'dif':-8, 'pts':30},
              {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':30, 'pg':17,'pe':4,'pp':9,'gf':41,'gc':26,'dif':15, 'pts':55},
              {'color':'#ffa500','shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':30, 'pg':12,'pe':8,'pp':9,'gf':43,'gc':33,'dif':10, 'pts':43},
              {'color':'#ffa500','shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':30, 'pg':10,'pe':11,'pp':9,'gf':41,'gc':37,'dif':4, 'pts':41},
              {'color':0,'shortname':'curico', 'rivalName':'Curicó U.', 'pj':30, 'pg':7,'pe':10,'pp':13,'gf':32,'gc':39,'dif':-7, 'pts':31},
              {'color':'#ffa500','shortname':'rangers', 'rivalName':'Rangers', 'pj':30, 'pg':10,'pe':13,'pp':7,'gf':35,'gc':35,'dif':0, 'pts':43},
              {'color':'#ffa500','shortname':'arica', 'rivalName':'San Marcos Arica', 'pj':30, 'pg':14,'pe':6,'pp':10,'gf':39,'gc':35,'dif':4, 'pts':48},
              {'color':'#ff3355','shortname':'morning', 'rivalName':'S. Morning', 'pj':30, 'pg':10,'pe':8,'pp':12,'gf':27,'gc':36,'dif':-9, 'pts':29},
              {'color':0,'shortname':'sanluis', 'rivalName':'San Luis', 'pj':30, 'pg':9,'pe':12,'pp':9,'gf':30,'gc':35,'dif':-5, 'pts':39},
              {'color':0,'shortname':'temuco', 'rivalName':'Dep. Temuco', 'pj':30, 'pg':7,'pe':12,'pp':11,'gf':34,'gc':39,'dif':-5, 'pts':33},
              {'color':0,'shortname':'santacruz', 'rivalName':'Dep. Santa Cruz', 'pj':30, 'pg':7,'pe':10,'pp':13,'gf':30,'gc':39,'dif':-9, 'pts':31},
              {'color':'#ffa500','shortname':'copiapo', 'rivalName':'Dep. Copiapó', 'pj':30, 'pg':14,'pe':10,'pp':6,'gf':38,'gc':20,'dif':18, 'pts':52},
              {'color':0,'shortname':'magallanes', 'rivalName':'Magallanes', 'pj':30, 'pg':9,'pe':8,'pp':13,'gf':28,'gc':33,'dif':-5, 'pts':35},
		{'color':'#ffa500','shortname':'concepcion', 'rivalName':'Dep. Concepción', 'pj':30, 'pg':12,'pe':7,'pp':11,'gf':42,'gc':38,'dif':4, 'pts':43}]
*/
    };

  }

  componentDidMount() {
	this.getKits();
	this.getStandings();
	/*let newtable2 = this.sortTable(this.state.table2);
                this.setState({table2:newtable2});*/
	}


generateTable(fixture, json){

let result = [];
const lastTable = json[fixture].table;
console.log(lastTable);
lastTable.forEach(team => {
  console.log(team.team, team.points);
  result.push({
    shortname: team.name,
    pj: team.played,
    pg: team.won,
    pe: team.drawn,
    pp: team.lost,
    gf: team.goals_for,
    gc: team.goals_against,
    dif: team.goal_difference,
    pts: team.points,
    rivalName: team.team
  });
});

return result;



}



handleMatchdayChange = (day) => {
    console.log("Selected matchday:", day);



        let newtable2 = this.generateTable(day-1,this.state.standings);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i]; 
        }
        this.setState({table2:sortednewtable2});


  };


 getStandings(){

        fetch("https://www.registrosudec.com:5000/standings", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: 78
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)

        let standingsObj = result['standings'];
        let regular = standingsObj[0];
        console.log("regular");
        console.log(regular);
        this.setState({ 
        standings: regular['standings_history']}) //[json1, json2,...]


        let newtable2 = this.generateTable(29,regular['standings_history']);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i]; 
        }
        this.setState({table2:sortednewtable2});



    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



 getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}

sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].pg < table[j+1].pg)) ||
		     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].pg == table[j+1].pg) && (table[j].gf < table[j+1].gf) )){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}




render(){


  let subT = this.subText('#295e1e', 'Asciende a Primera A 2026');
  let subD = this.subText('#ff3355', 'Desciende a Segunda División 2026');
console.log(this.state.id_list);
let subP = this.subText('#ffa500', 'Clasifica a liguilla de ascenso');

  return(

	<div style={{textAlign: 'center' }}>

	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Primera B 2025</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>
	<div style={{ height: '50px' }}></div>

	 <div>
      <span>Evolución de la tabla</span>
      <MatchdaySlider maxMatchday={this.state.maxMatchday} onChange={this.handleMatchdayChange} />
    </div>


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
	<div> * S. Morning tiene 9 puntos menos por deudas en torneo pasado</div>

	<div style={{ height: '10px' }}></div>
         {subT}
	 {subP}
	 {subD}
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Primera B 2025</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Primera B 2025</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Primera B 2025" />
     </div>


  )
}

}
export default PrimeraB2025;
